__turbopack_context__.v({
  "app": "article-apps-module-scss-module__pCtEqa__app",
  "apps": "article-apps-module-scss-module__pCtEqa__apps",
  "dark": "article-apps-module-scss-module__pCtEqa__dark",
  "light": "article-apps-module-scss-module__pCtEqa__light",
  "section": "article-apps-module-scss-module__pCtEqa__section",
});
